<div class="auth-wrapper d-flex no-block justify-content-center align-items-center" style="background:url(assets/images/big/auth-bg.jpg) no-repeat center center;">
    <div>
<!--        <div class="alert alert-primary">-->
<!--            <span class="mr-1">Username : admin</span> |-->
<!--            <span class="ml-1">Password : admin123</span>-->
<!--        </div>-->
        <div class="auth-box" style="background: #696969">
            <div id="loginform" [ngClass]="{'d-none': recoverform}">
                <div class="text-center">
                    <span class="db"><img src="assets/images/sparq_logo.gif" alt="logo" style="width: 200px" /></span>
                    <h5 class="font-medium mb-4" style="color:white">Sign In</h5>
                </div>
                <div *ngIf="msg" class="alert alert-danger">{{ msg }}</div>
                <!-- Form -->
                <div class="row">
                    <div class="col-12">
                        <form class="form-horizontal mt-3" id="loginform">
                            <div class="input-group mb-3" *ngIf="view === 'enter-email'">
                                <span class="input-group-text" id="basic-addon1"><i class="ti-user"></i></span>
                                <input type="email" class="form-control form-control-lg" placeholder="Email" aria-label="Email"
                                       aria-describedby="basic-addon1" required [(ngModel)]="email" name="email" #emailInput="ngModel"
                                       (keyup.enter)="authorize(email, loginCode)" #emailField>
                            </div>
                            <div class="input-group mb-3" *ngIf="view === 'enter-code'">
                                <span class="input-group-text" id="basic-addon2"><i class="ti-pencil"></i></span>

                                <input type="tel" class="form-control form-control-lg" placeholder="Login Code" aria-label="Login Code"
                                aria-describedby="basic-addon1" required [(ngModel)]="loginCode" name="loginCode" #loginCodeInput="ngModel"
                                (keyup.enter)="authorize(email, loginCode)" pattern="[0-9]{6}" maxlength="6" #loginCodeField>
                            </div>
<!--                            <div class="form-group row">-->
<!--                                <div class="col-md-12">-->
<!--                                    <div class="form-check">-->
<!--                                        <input type="checkbox" class="form-check-input" id="customCheck1">-->
<!--                                        <label class="form-check-label" for="customCheck1">Remember me</label>-->
<!--                                        <a (click)="showRecoverForm()" href="javascript:void(0)" id="to-recover" class="text-dark float-end"><i-->
<!--                                        class="fa fa-lock me-1"></i> Forgot pwd?</a>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
                            <div class="form-group text-center mt-3">
                                <div class="col-xs-12 pb-4">
                                    <button class="btn d-block w-100 btn-lg btn-info" type="button" [disabled]="loading"
                                            (click)="authorize(email, loginCode)">
                                        <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        {{ submitLabel }}
                                    </button>
                                </div>
                            </div>
<!--                            <div class="row">-->
<!--                                <div class="col-xs-12 col-sm-12 col-md-12 mt-2 text-center">-->
<!--                                    <div class="social">-->
<!--                                        <a href="javascript:void(0)" class="btn btn-info" data-toggle="tooltip" title=""-->
<!--                                            data-original-title="Login with Facebook"> <i aria-hidden="true" class="fab fa-facebook"></i>-->
<!--                                        </a>-->
<!--                                        <a href="javascript:void(0)" class="btn btn-danger ms-2" data-toggle="tooltip" title=""-->
<!--                                            data-original-title="Login with Google"> <i aria-hidden="true" class="fab fa-google-plus"></i>-->
<!--                                        </a>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="form-group m-b-0 mt-2">-->
<!--                                <div class="col-sm-12 text-center">-->
<!--                                    Don't have an account? <a href="#/authentication/signup" class="text-info ms-1"><b>Sign-->
<!--                                    Up</b></a>-->
<!--                                </div>-->
<!--                            </div>-->
                        </form>
                    </div>
                </div>
            </div>
<!--            <div id="recoverform" [ngClass]="{'d-block': recoverform}">-->
<!--                <div class="logo">-->
<!--                    <span class="db"><img src="assets/images/logo-icon.png" alt="logo" /></span>-->
<!--                    <h5 class="font-medium mb-4">Recover Password</h5>-->
<!--                    <span>Enter your Email and instructions will be sent to you!</span>-->
<!--                </div>-->
<!--                <div class="row mt-3">-->
<!--                    &lt;!&ndash; Form &ndash;&gt;-->
<!--                    <form class="col-12">-->
<!--                        &lt;!&ndash; email &ndash;&gt;-->
<!--                        <div class="form-group row">-->
<!--                            <div class="col-12">-->
<!--                                <input class="form-control form-control-lg" type="email" required="" placeholder="Username">-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        &lt;!&ndash; pwd &ndash;&gt;-->
<!--                        <div class="row mt-3">-->
<!--                            <div class="col-12">-->
<!--                                <button class="btn d-block w-100 btn-lg btn-danger" type="submit" name="action">Reset</button>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </form>-->
<!--                </div>-->
<!--            </div>-->
        </div>
    </div>
</div>
